module.exports = __webpack_public_path__ + "static/image_6-a6762470e18481bac48dfac38743746c.jpg";